<template>
    <div v-if="loadingLogin">
        <p>Cargando...</p>
    </div>
    <div v-else-if="logged">
        <button class="logout" @click="logout">
            {{name}}: Logout
        </button>
    </div>
    <div v-else>
        <a :href="loginUrl"
            class="login">
            Iniciar sesión
        </a>
    </div>
</template>

<style scoped>
.logout{
  color: white;
  background-color: var(--mainred);
  height: 35px;
  width: fit-content;
  padding: 0 15px;
  border: 0px;
  border-radius: 18px;
  cursor: pointer;
}
</style>

<script>
export default {
    data(){
        return{
            urlLogout:'https://shiny-bienenstitch-665b69.netlify.app', /*  http://192.168.1.34:8081/ */
            loginUrl:"https://connect.deezer.com/oauth/auth.php?app_id=545582&redirect_uri=https://shiny-bienenstitch-665b69.netlify.app&response_type=token&perms=basic_access,email,offline_access,manage_library,delete_library,listening_history",
            loadingLogin: true,
            logged: false,
            name: localStorage.getItem('name') || null
            /* #access_token=frZhSQuSWRrJJu94adqIfLisxBLSntLZSaqt43M7jXKxaKNESr&expires=0 */ 
        }
    },
    methods:{
        logout(){
            localStorage.removeItem('token')
            localStorage.removeItem('name')
            window.location.href=this.urlLogout
        },
        saveTokens(){
            if(localStorage.getItem('token')===null && this.$route.hash){
                console.log('que est apaasando doctor garciaaa2')
                localStorage.setItem('token', this.$route.hash.toString().slice('14', this.$route.hash.indexOf('&')))
                const url = this.baseUrl + '/user/me?access_token='+localStorage.getItem('token')
                fetch(url)
                .then(response=>response.json())
                .then(json=> {
                    localStorage.setItem('name', json.name)
                    this.name = json.name
                    console.log(json)
                });
                this.logged=true
                console.log('se settearon los tokens y se puso true el logged')
            }
        }
    },
    watch:{
        $route(){
            this.loadingLogin=true
            console.log(localStorage.getItem('token'))
            this.saveTokens()
            this.loadingLogin=false
        }
    },
    mounted(){
        if(localStorage.getItem('name')==null){
            this.logged=false
        }
        else this.logged=true
    }
}
</script>